import React from 'react';

const collaborations = [
  { name: 'Zoologisk Have', line: 'ZooLab' },
  { name: 'Rosenborg Slot', line: 'Rosenborg' },
  { name: 'Hans Egedes Kirke', line: 'Tolvkanten / Tiny Church' },
  { name: 'Realdania', line: 'Støttede restaureringen af Store Tårn' },
];

export const Collaborations = () => (
  <section data-testid="collaborations-section" className="py-32 bg-white">
    <div className="max-w-6xl mx-auto px-8 md:px-16 xl:px-0">
      <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-16">Udvalgte projekter og samarbejder</h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-12 gap-y-12 border-t border-gray-200 pt-12">
        {collaborations.map((c) => (
          <li key={c.name} data-testid={`collaboration-${c.name.toLowerCase().replace(/\s+/g, '-')}`}>
            <p className="text-xl md:text-2xl font-light text-gray-900 tracking-tight">{c.name}</p>
            <p className="mt-2 text-sm text-gray-500 font-light">{c.line}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
